import { render, staticRenderFns } from "./ReceiveProjectInvitation.vue?vue&type=template&id=661c16a6&"
import script from "./ReceiveProjectInvitation.vue?vue&type=script&lang=ts&"
export * from "./ReceiveProjectInvitation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports